import React from 'react'
import Text from 'ui/acro/typography/Text'

const PageHeader = ({ title, subTitle, style }) => {
  return (
    <>
      <Text
        fontFamily='Proxima-Nova'
        fontWeight='500'
        letterSpacing='.12em'
        fontSize={['54px', '60px']}
        textTransform='uppercase'
        textAlign='center'
        lineHeight={['25px', '45px']}
        {...style}
      >
        {title}
      </Text>
      {subTitle && (
        <Text
          fontFamily='Proxima-Nova'
          fontWeight='500'
          fontStyle='normal'
          lineHeight={['20.25px', null, null, '25px']}
          letterSpacing={['.08em', null, null, '.12em']}
          color='#333333'
          fontSize={['20px', '20px', '24px', '24px']}
          pt={['5px', '14px']}
          pb={['14px', '29px']}
          textTransform='uppercase'
        >
          {subTitle}
        </Text>
      )}
    </>
  )
}
export default PageHeader
